import { css } from '@emotion/react';
import { Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { Variants } from 'motion/react';

export const buttonVariants: Variants = {
  'card-hover': {
    opacity: 1,
    transition: {
      duration: 0.22,
      ease: [0.22, 0.9, 0.53, 1],
    },
  },
  'card-selected': {
    opacity: 1,
    transition: {
      duration: 0.22,
      ease: [0.22, 0.9, 0.53, 1],
    },
  },
};

const styles = {
  header: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
  `,
  title: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
  subtitle: css`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  sourceContainer: css`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  buttonsContainer: css`
    display: flex;
    align-items: center;
    opacity: 0;
    background-color: white;
    border-radius: 8px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
